import 'react-phone-input-2/lib/style.css'

import PropTypes from 'prop-types'
import { useState } from 'react'
import PhoneInput from 'react-phone-input-2'

import ConfirmationDialog from '../../ConfirmationDialog/index'
import styles from './AddGuestWithPhone.module.css'

const AddGuestWithPhone = ({ handleSubmit, handleClose }) => {
  const [phone, setPhone] = useState('')

  function handlePhoneChange(value) {
    setPhone(value)
  }

  return (
    <ConfirmationDialog
      title="Add guest"
      positiveMessage="Next"
      negativeMessage="Cancel"
      onConfirm={() => handleSubmit(phone)}
      onClose={handleClose}
      actLikeForm={true}
      hasFixedTopMargin={true}
    >
      <div className={styles.container}>
        <p className={styles.phoneLabel}>Cell phone number</p>
        <PhoneInput
          value={phone}
          onChange={handlePhoneChange}
          defaultCountry="us"
          placeholder="Cell phone number"
          inputExtraProps={{
            autoComplete: 'off'
          }}
        />
      </div>
    </ConfirmationDialog>
  )
}

AddGuestWithPhone.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default AddGuestWithPhone
